import { ErrorPage, getErrorMessage } from '@idu-nightlife/ui-kit';
import { ReactNode } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { useLocation } from 'react-router';

const PageContentErrorFallback = ({ error }: FallbackProps) => (
  <ErrorPage message="This page failed to load" details={getErrorMessage(error)} />
);

/**
 * Contains a render error to the content region, so the global nav survives it and the user
 * can switch to another app or venue instead of facing a blank page.
 */
export const PageContentErrorBoundary = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary FallbackComponent={PageContentErrorFallback} resetKeys={[pathname]}>
      {children}
    </ErrorBoundary>
  );
};
